<template>
  <div id="pagesWrapper">
    <nav
      v-for="table in visibleTables"
      :key='table.id'
      class="panel">
      <p class="panel-heading">{{ table.name}}</p>

      <router-link
        v-for="page in visible(table.pages)"
        :key="page.id"
        :to="{ name: 'page', params: { id: page.id } }"
        class="panel-block">

        <span class="panel-icon">
          <i class="fas fa-clipboard-list" aria-hidden="true"></i>
        </span>

        {{ page.name }}
      </router-link>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      tables: 'tables/tables',
      bundle: 'bundles/bundle'
    }),
    visibleTables () {
      if (this.bundle) {
        return this.tables.filter(table => !this.bundle.has_disabled['tables'].includes(table.id))
      }

      return []
    }
  },
  methods: {
    visible (pages) {
      return pages.filter(page => !this.bundle.has_disabled['pages'].includes(page.id))
    }
  }
}
</script>

<style lang="css">
</style>
